module.exports = __webpack_public_path__ + "fonts/nexa-light-webfont.52e6fd6d.woff";